import { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";
import { commonStyles } from "../tables/styles";

type StyleObject = SystemStyleObject<Theme>;
type StyleGroup = Record<string, StyleObject>;
type Styles = Record<string, StyleGroup>;

export default (theme: Theme): Styles => {
  const styles = commonStyles(theme);

  return {
    Heatmap: {
      container: {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      },

      heatmap: {
        width: "100%",
        maxWidth: "1000px",
        height: "auto",
        "@media print": {
          maxWidth: "150mm",
        },
        svg: {
          "& > text": {
            fontSize: "var(--font-size-s)",
            "@media print": {
              fontSize: "10pt",
            },
          },
        },
      },

      legend: {
        width: "100%",
        maxWidth: "400px",
        height: "auto",
        "@media print": {
          maxWidth: "100mm",
        },
      },
    },

    LuminanceHeatmap: {
      ...styles,

      table: {
        ...styles.table,
        ".MuiTableCell-root": {
          ...styles.cell,
          "&:first-of-type": {
            textAlign: "left",
          },
          "@media print": {
            paddingY: "1mm",
            fontSize: "8pt",
            width: "25mm",
            "&:nth-of-type(1)": {
              width: "30mm",
            },
          },
        },
      },
    },

    IluminanceBordersHeatmap: {
      ...styles,
    },

    IlluminanceHeatmap: {
      ...styles,
    },
  };
};
